module.exports = __webpack_public_path__ + "static/media/message.70ae0a6f.mp3";